
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Button, Container, Grid, Typography, Link } from '@mui/material';
import { useCookies } from 'react-cookie';
import axios from "axios";
import { config } from "../../data/config";
import Swal from 'sweetalert2'
import { Edit, DeleteForever, Star, Map } from '@mui/icons-material';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { useEffect } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}



export default function AreaList() {
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [page, setPage] = React.useState(1);
    const [data, setData] = React.useState(null);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        reload()
    };

    const reload = async () => {
        var path = `${config.url}/city?limit=10&page=${page}`;
        try {
            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "*",
                    'Authorization': cookies.token
                }
            });
            setData(res.data)


        } catch (error) {
            console.log(error)
        }

    }
    useEffect(() => {
        reload();
    }, []);
    return (
        <Box>

            <Container>
                <Box pb={3} pt={3}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link underline="hover" color="inherit" href="/dashboard">
                            Dashboard
                        </Link>

                        <Typography color="text.primary">City List</Typography>
                    </Breadcrumbs>
                    <Typography variant='h1' color={'gray'} fontSize={34}>City List</Typography>
                </Box>
                <Paper >
                    <Container>
                        <Box pt={4}>
                            <Stack direction={'row'} spacing={1}>

                                <Button variant={'contained'} href='/dashboard/city/new'>Add New City</Button>

                                <Button variant={'contained'} onClick={(e) => { reload() }}>Reload</Button>
                            </Stack>
                        </Box>
                    </Container>
                    {
                        data != null &&
                        <Box pt={4} p={4}>

                            <TableContainer component={Paper}>

                                <Table sx={{ minWidth: 650 }} aria-label="caption table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Zones</TableCell>
                                            <TableCell>Action</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {data.docs.map((row) => (
                                            <TableRow key={row.name}>
                                                <TableCell component="th" scope="row">
                                                    {row.name} {row.rule == 1 && <Star fontSize='small' color='primary'></Star>}
                                                </TableCell>
                                                <TableCell >
                                                    <Link href={`/dashboard/zones/${row._id['$oid']}`} underline='none' color={'#333'}>
                                                        <Map />

                                                    </Link>
                                                </TableCell>
                                                <TableCell >
                                                    <Stack direction={'row'} spacing={1}>
                                                        <Link href={`/dashboard/city/edit/${row._id['$oid']}`} underline='none' color={'#333'}>
                                                            <Edit />

                                                        </Link>


                                                        <DeleteForever />

                                                    </Stack>
                                                </TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Box p={2}>
                                <Pagination
                                    onChange={handleChangePage}
                                    defaultPage={data.page}
                                    count={data.totalpage}
                                    color="primary"
                                />

                            </Box>


                        </Box>
                    }
                </Paper>
            </Container>
        </Box>
    );
}